import React, {useEffect} from "react";
import {useLocation, Route, Routes, Navigate} from "react-router-dom";
import routes from "routes";
import {PublicFooter, PublicHeader} from "../components/Public/Shared";

export default function PublicLayout(props: any) {
    const location = useLocation();

    useEffect(() => {
        if (!location.hash) {
            window.scrollTo(0, 0);
            return;
        }
        const id = decodeURIComponent(location.hash.slice(1));
        const scrollToHash = () => {
            document.getElementById(id)?.scrollIntoView({behavior: "smooth", block: "start"});
        };
        const first = window.setTimeout(scrollToHash, 50);
        const second = window.setTimeout(scrollToHash, 400);
        return () => {
            window.clearTimeout(first);
            window.clearTimeout(second);
        };
    }, [location.pathname, location.hash]);

    const getRoutes = (routes: any[]) => {
        return routes.map((prop, index) => {
            if (prop.layout === "/public") {
                return (
                    <Route path={prop.path} element={prop.component} key={index}/>
                );
            } else {
                return null;
            }
        });
    };

    return (
        <div className="public-page">
            <PublicHeader/>
            <main className="oec-main">
                <Routes location={location} key={location.pathname}>
                    {getRoutes(routes)}
                    <Route path="*" element={<Navigate to="/" replace/>}/>
                </Routes>
            </main>
            <PublicFooter/>
        </div>
    );
};
